import API from "../../../../services/api-request";
import state from "../../../../config/valtio/store";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Table, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import FilterMenu from "./filter-menu";
import AddProductCost from "./modal-add-product-cost";
import EditProductCost from "./modal-edit-product-cost";
import "../../../../assets/css/style-table.css";

const { confirm } = Modal;

const ProductCost = () => {
  const [dataProductCost, setDataProductCost] = useState([]);
  const [dataProductCostFilter, setDataProductCostFilter] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const getProductCost = async () => {
    state.LOADING = true;

    await API.Get("storage-cost")
      .then((result) => {
        setDataProductCost(result?.data);
        setDataProductCostFilter(result?.data);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Product Cost Data!");
      });

    state.LOADING = false;
  };

  useEffect(() => {
    getProductCost();
  }, []);

  // Delete Confirm
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`storage-cost/${data.id}`)
          .then(() => {
            message.success("Product Cost has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete Product Cost");
            console.error(err);
          })
          .finally(() => {
            getProductCost();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Tipe",
      dataIndex: "product_type",
      key: "product_type",
      sorter: (a, b) => {
        if (a.product_type?.size === null || a.product_type?.size === "-")
          return 1;
        if (b.product_type?.size === null || b.product_type?.size === "-")
          return -1;
        return a.product_type?.size.localeCompare(b.product_type?.size);
      },
      render: (product_type) => (product_type ? product_type?.size : "-"),
    },
    {
      title: "Harga Minggu Pertama",
      dataIndex: "first_week_fee",
      key: "first_week_fee",
      sorter: (a, b) => {
        if (a.first_week_fee === null || a.first_week_fee === "-") return 1;
        if (b.first_week_fee === null || b.first_week_fee === "-") return -1;
        return a.first_week_fee - b.first_week_fee;
      },
      render: (first_week_fee) => (first_week_fee ? first_week_fee : "-"),
    },
    {
      title: "Harga Harian",
      dataIndex: "daily_fee",
      key: "daily_fee",
      sorter: (a, b) => {
        if (a.daily_fee === null || a.daily_fee === "-") return 1;
        if (b.daily_fee === null || b.daily_fee === "-") return -1;
        return a.daily_fee - b.daily_fee;
      },
      render: (daily_fee) => (daily_fee ? daily_fee : "-"),
    },
    {
      title: "Tanggal Efektif",
      dataIndex: "efective_date",
      key: "efective_date",
      sorter: (a, b) => {
        if (a.efective_date === null || a.efective_date === "-") return 1;
        if (b.efective_date === null || b.efective_date === "-") return -1;
        return a.efective_date.localeCompare(b.efective_date);
      },
      render: (efective_date) =>
        efective_date ? dayjs(efective_date).format("YYYY-MM-DD") : "-",
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSearch = async (val) => {
    let data = dataProductCost.filter((product) =>
      product?.product_type?.size.toLowerCase().includes(val.toLowerCase()),
    );

    setDataProductCostFilter(data);
  };

  const onClear = async (val) => {
    getProductCost();
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <>
      <FilterMenu onShowAdd={onShowAdd} onSearch={onSearch} onClear={onClear} />

      {/* Product Cost Table */}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataProductCostFilter}
        rowClassName={rowClassName}
        scroll={{
          x: 1000,
        }}
        size="large"
      />

      {/* Modal Add Product Cost*/}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddProductCost
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetProductCost={getProductCost}
        />
      </div>

      {/* Modal Edit Product Cost*/}
      <EditProductCost
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetProductCost={getProductCost}
        selectedData={selectedData}
      />
    </>
  );
};

export default ProductCost;
